import { useEffect } from 'react';
import { getMediaFileId } from '../utils/getMediaFileId';
import {
	collectStoryMediaIds,
	preloadStoryMedia,
} from '../utils/preloadStoryMedia';

export const useStoryMediaPreload = (
	storyPersons,
	activePersonIdx,
	{ open = false, preloadPeeks = false } = {},
) => {
	useEffect(() => {
		if (!storyPersons.length) {
			return;
		}

		const ids = new Set();

		if (preloadPeeks) {
			storyPersons.forEach((storyPerson) => {
				collectStoryMediaIds(storyPerson).forEach((id) => ids.add(id));
			});
		}

		if (open && activePersonIdx >= 0) {
			const neighborIndices = [
				activePersonIdx - 1,
				activePersonIdx,
				activePersonIdx + 1,
			];

			neighborIndices.forEach((idx) => {
				if (idx < 0 || idx >= storyPersons.length) {
					return;
				}

				collectStoryMediaIds(storyPersons[idx]).forEach((id) => ids.add(id));
			});
		}

		preloadStoryMedia([...ids]);
	}, [storyPersons, activePersonIdx, open, preloadPeeks]);
};

export const useStoriesBarPreload = (persons) => {
	useEffect(() => {
		if (!persons.length) {
			return;
		}

		const ids = persons.flatMap((person) => {
			const profileId = getMediaFileId(person.profile_image);
			const storyIds = (person.stories_images || []).map((image) =>
				getMediaFileId(image),
			);

			return [profileId, ...storyIds].filter(Boolean);
		});

		preloadStoryMedia(ids);
	}, [persons]);
};
